import React, {useCallback} from 'react';
import usePharmacy from './hooks/use-pharmacy.hook';
import Clickable from 'components/atoms/button/clickable/clickable.component';
import Headline from 'components/atoms/typography/headline/headline.component';
import {
  TypographyFontStyles,
  TypographySizes,
} from 'components/atoms/typography/base-text/constants';
import COLORS from 'theme/colors/colors';

export default function Pharmacy() {
  const {pharmacyList, navigateToPharmacyDetails} = usePharmacy();

  const renderPharmacies = useCallback(() => {
    return pharmacyList?.map((val) => (
      <Clickable
        key={val}
        onClick={() => navigateToPharmacyDetails(val)}
        style={{
          flexDirection: 'column',
          display: 'flex',
          flex: 1,
          borderColor: '#3e3e3e',
          borderWidth: 3,
          borderStyle: 'solid',
          backgroundColor: COLORS.blackHighTransparent,
          justifyContent: 'center',
          alignItems: 'center',
          margin: 15,
        }}>
        <Headline
          size={TypographySizes['3XL']}
          stringProps={{plainText: val}}
        />
      </Clickable>
    ));
  }, [navigateToPharmacyDetails, pharmacyList]);

  return (
    <div>
      <div style={{padding: 25}}>
        <Headline
          stringProps={{plainText: 'Available Branches'}}
          size={TypographySizes['3XL']}
          fontStyle={TypographyFontStyles.Bold}
        />
      </div>
      <div style={{flexDirection: 'row', display: 'flex'}}>
        {renderPharmacies()}
      </div>
    </div>
  );
}
